import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMinimizeMode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 5.4375C12.9822 5.4375 12.5625 5.01777 12.5625 4.5V2.25C12.5625 1.93934 12.3107 1.6875 12 1.6875C11.6893 1.6875 11.4375 1.93934 11.4375 2.25V4.5C11.4375 5.63909 12.3609 6.5625 13.5 6.5625H15.75C16.0607 6.5625 16.3125 6.31066 16.3125 6C16.3125 5.68934 16.0607 5.4375 15.75 5.4375H13.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.4375 13.5C5.4375 12.9822 5.01777 12.5625 4.5 12.5625H2.25C1.93934 12.5625 1.6875 12.3107 1.6875 12C1.6875 11.6893 1.93934 11.4375 2.25 11.4375H4.5C5.63909 11.4375 6.5625 12.3609 6.5625 13.5V15.75C6.5625 16.0607 6.31066 16.3125 6 16.3125C5.68934 16.3125 5.4375 16.0607 5.4375 15.75V13.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5625 13.5C12.5625 12.9822 12.9822 12.5625 13.5 12.5625H15.75C16.0607 12.5625 16.3125 12.3107 16.3125 12C16.3125 11.6893 16.0607 11.4375 15.75 11.4375H13.5C12.3609 11.4375 11.4375 12.3609 11.4375 13.5V15.75C11.4375 16.0607 11.6893 16.3125 12 16.3125C12.3107 16.3125 12.5625 16.0607 12.5625 15.75V13.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.4375 4.5C5.4375 5.01777 5.01777 5.4375 4.5 5.4375H2.25C1.93934 5.4375 1.6875 5.68934 1.6875 6C1.6875 6.31066 1.93934 6.5625 2.25 6.5625H4.5C5.63909 6.5625 6.5625 5.63909 6.5625 4.5V2.25C6.5625 1.93934 6.31066 1.6875 6 1.6875C5.68934 1.6875 5.4375 1.93934 5.4375 2.25V4.5Z",
			fill: "#33373D"
		})
	]
});
export { SvgIconMinimizeMode as ReactComponent };
